//@flow
import * as React from 'react';
import _ from 'lodash';
import { BootstrapTable } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import type { Options } from '../../services/defaultService';

type Props = {
  children: any,
  defaultOrder: string,
  defaultDirection: string,
  classSignal: string,
  service: any,
  filter: any,
  onRowClick: any,
  submitFilter: boolean,
};

type State = {
  data: Array<any>,
  dataTotalSize: number,
  currentPage: number,
  order: string,
  direction: string,
  naturalOrder: boolean,
};

class DataTableRelatorio extends React.PureComponent<Props, State> {
  static defaultProps = {
    loadOnInit: true,
  };
  constructor(props: Props) {
    super(props);

    let data = [];
    let dataTotalSize = 0;

    let currentPage =
      this.props.currentPage && this.props.controller == this.props.page
        ? this.props.currentPage
        : 1;

    this.state = {
      data,
      dataTotalSize,
      currentPage,
      order: this.props.defaultOrder,
      direction: this.props.defaultDirection
        ? this.props.defaultDirection
        : 'asc',
      naturalOrder: true,
    };
  }

  componentDidMount() {
    if (this.props.loadOnInit) {
      this.resetTable();
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.filter && nextProps.submitFilter) {
      this.resetTable(nextProps.filter);
    }
  }

  resetTable = (filter?: any) => {
    this.requestData(
      {
        pageSize: 20,
        page: 1,
        order: this.state.order,
        direction: this.state.direction,
        naturalOrder: this.state.naturalOrder,
      },
      filter
    );
  };

  //Usado para atualizar a tabela de fora do componente.
  updateTable = () => {
    return this.requestData({
      pageSize: 20,
      page: this.state.currentPage,
      order: this.state.order,
      direction: this.state.direction,
      naturalOrder: this.state.naturalOrder,
    });
  };

  requestData = (options: Options, filter?: any) => {
    let service = this.props.service.findByFiltro;
    if (this.props.noFindByFilter) {
      service = this.props.service;
    }
    this.props.loading(true);
    return service(
      {
        pageSize: options.pageSize,
        page: options.page,
        order: options.order,
        direction: options.direction,
        naturalOrder: options.naturalOrder,
      },
      filter ? filter : this.props.filter
    )
      .then((response) => {
        let data = response.data;
        this.setState({
          data: data.data,
          dataTotalSize: data.dataTotalSize,
          currentPage: options.page,
          order: options.order,
          direction: options.direction,
        });
        if (this.props.onDataUpdate) {
          this.props.onDataUpdate(data.data);
        }
        this.props.changeTitle(`${data.dataTotalSize}`);
        this.props.loading(false);
        return data.data;
      })
      .catch((error) => {
        this.props.loading(false);
        console.log(error);
      });
  };

  handlePageChange = (page: number) => {
    this.setState({
      currentPage: page,
    });

    this.requestData({
      pageSize: 20,
      page: page,
      order: this.state.order,
      direction: this.state.direction,
      naturalOrder: this.state.naturalOrder,
    });
  };

  handleSortChange = (sortName: string, sortOrder: string) => {
    this.setState({
      order: sortName,
      direction: sortOrder,
      naturalOrder: false,
    });
    this.requestData({
      pageSize: 20,
      page: this.state.currentPage,
      order: sortName,
      direction: sortOrder,
      naturalOrder: false,
    });
  };

  renderShowsTotal = (start: number, to: number, total: number) => {
    return (
      <p className={'total-text'}>
        Exibindo {to} de {total} registros
      </p>
    );
  };

  render() {
    const selectRow = {
      mode: 'radio',
      clickToSelect: true,
      hideSelectColumn: true,
      className: 'selectRow',
      onSelect: (row, isSelect, rowIndex, e) => {},
    };
    return (
      <BootstrapTable
        version="4"
        data={this.state.data}
        remote={true}
        pagination={true}
        search={false}
        multiColumnSearch={false}
        fetchInfo={{ dataTotalSize: this.state.dataTotalSize }}
        insertRow={false}
        deleteRow={false}
        exportCSV={false}
        striped={false}
        bordered={false}
        selectRow={selectRow}
        headerContainerClass=""
        tableContainerClass={`${this.props.onRowClick ? 'action' : ''} ${
          this.props.classSignal
        }`}
        options={{
          sizePerPage: 20,
          sizePerPageList: [10, 20, 50, 100],
          page: this.state.currentPage,
          onPageChange: this.handlePageChange,
          onSortChange: (sortName, sortOrder) => {
            let column = _.filter(this.props.columns, { path: sortName });
            this.handleSortChange(
              _.isEmpty(column) ? sortName : column[0].pathFilter,
              sortOrder
            );
          },
          noDataText: 'Nenhuma informação encontrada.',
          paginationShowsTotal: this.renderShowsTotal,
          prePage: 'Anterior', // Previous page button text
          nextPage: 'Próximo', // Next page button text
          firstPage: 'Primeiro', // First page button text
          lastPage: 'Último', // Last page button text
          prePageTitle: 'Anterior', // Previous page button title
          nextPageTitle: 'Próximo', // Next page button title
          firstPageTitle: 'Primeiro', // First page button title
          lastPageTitle: 'Último',
          alwaysShowAllBtns: true,
          withFirstAndLast: true,
          paginationSize: 3,
          hideSizePerPage: true,
          sortIndicator: true,
          onRowClick: this.props.onRowClick,
        }}
      >
        {this.props.children}
      </BootstrapTable>
    );
  }
}
function mapStateToProps(state) {
  const { page, currentPage } = state.defaultFilter;

  return {
    page,
    currentPage,
  };
}

export default DataTableRelatorio;
